export const FADE_DURATION = 350
export const FADE_DELAY = 10
